/**
 * Client Layout Wrapper pour les pages protégées
 * 
 * Ce composant gère automatiquement le refresh de session pour toutes les pages protégées.
 * Il doit être utilisé dans le layout des pages protégées.
 */

'use client'

import { useSessionRefresh } from '@/lib/auth/useSessionRefresh'
import { useEffect } from 'react'
import { logger } from '@/lib/logger'

interface ProtectedLayoutClientProps {
  children: React.ReactNode
}

export function ProtectedLayoutClient({ children }: ProtectedLayoutClientProps) {
  // Activer le refresh automatique de session
  useSessionRefresh({
    checkInterval: 60000,      // Vérifier toutes les 60 secondes
    refreshThreshold: 300000,  // Rafraîchir si le token expire dans moins de 5 minutes
    onRefresh: () => {
      logger.info('[Protected Layout] Session refreshed successfully')
    },
    onRefreshError: (error) => {
      logger.error('[Protected Layout] Session refresh failed', error)
      // La redirection vers /signin est gérée automatiquement par le hook
    },
  })

  useEffect(() => {
    logger.info('[Protected Layout] Auto session refresh enabled')
  }, [])

  return <>{children}</>
}
